import { VisibilityState } from "@tanstack/react-table";

export const stripePaymentColumnVisibility: VisibilityState = {
  slNo: true,
  Amount: true,
  CreatedAt: true,
  MembershipDurationId: false,  // hidden by default
  Product: true,
  Remarks: false,  // hidden by default
  Status: true,
  TransactionId: true,
  UpdatedAt: true,
  UserId: true,
};
